import strings from '../../../../../../common/Translation/Translate';
import { FormModel } from '../../../../../../components/Form';
import { Validators } from '../../../../../../utils/validators';

export const LocalizedAttributeForm = (): FormModel[] => {
  return [
    {
      label: strings.organization_section4,
      value: '',
      type: 'section',
      placeholder: '',
      field: 'organization_section4',
      autoFocus: true,
      validators: [],
      required: false,
      responsive: { xs: 12, sm: 12 },
    },
    {
      label: strings.roomReservationText,
      value: '',
      size: 'medium',
      type: 'text',
      typeValue: 'text',
      variant: 'outlined',
      placeholder: '',
      field: 'roomReservationText',
      multiline: true,
      validators: [{ check: Validators.validateMandatoryField }, { check: Validators.validateString }],
      responsive: { xs: 12, sm: 12 },
      required: true,
      isMulti: true,
      minRows: 2,
      maxRows: 5,
    },
    {
      label: strings.organization_text_rfqTerms,
      value: '',
      size: 'medium',
      type: 'text',
      typeValue: 'text',
      variant: 'outlined',
      placeholder: '',
      field: 'rfqTerms',
      multiline: true,
      validators: [{ check: Validators.validateMandatoryField }, { check: Validators.validateString }],
      responsive: { xs: 12, sm: 12 },
      required: true,
    },
    {
      label: strings.organization_section5,
      value: '',
      type: 'section',
      placeholder: '',
      field: 'organization_section5',
      autoFocus: true,
      validators: [],
      required: false,
      responsive: { xs: 12, sm: 12 },
    },
    {
      label: strings.organization_text_description,
      value: '',
      size: 'medium',
      type: 'text',
      typeValue: 'text',
      variant: 'outlined',
      placeholder: '',
      field: 'description',
      multiline: true,
      validators: [{ check: Validators.validateMandatoryField }, { check: Validators.validateString, max: 2000 }],
      responsive: { xs: 12 },
      required: true,
      maxRows: 5,
    },

    {
      label: strings.organization_text_contractTemplate,
      value: '',
      type: 'upload',
      accept: 'text/html',
      placeholder: '',
      field: 'contractTemplate',
      validators: [],
      sx: { alignSelf: 'flex-start' },
      responsive: { xs: 12, md: 6 },
      required: false,
      multiline: false,
    },
    {
      label: strings.organization_text_beoTemplate,
      value: '',
      type: 'upload',
      accept: 'text/html',
      placeholder: '',
      field: 'beoTemplate',
      validators: [],
      sx: { alignSelf: 'flex-start' },
      responsive: { xs: 12, md: 6 },
      required: false,
      multiline: false,
    },
    {
      label: strings.organization_text_invoiceTemplate,
      value: '',
      type: 'upload',
      accept: 'text/html',
      placeholder: '',
      field: 'invoiceTemplate',
      validators: [],
      sx: { alignSelf: 'flex-start' },
      responsive: { xs: 12, md: 6 },
      required: false,
      multiline: false,
    },
    {
      label: strings.organization_text_menuPlan,
      value: '',
      type: 'upload',
      accept: 'application/pdf',
      placeholder: '',
      field: 'menuPlan',
      validators: [],
      responsive: { xs: 12, md: 6 },
      required: false,
      multiline: false,
    },
    {
      label: strings.organization_text_proposalTemplate,
      value: '',
      type: 'upload',
      accept: 'text/html',
      placeholder: '',
      field: 'proposalTemplate',
      validators: [],
      sx: { alignSelf: 'flex-start' },
      responsive: { xs: 12, md: 6 },
      required: false,
      multiline: false,
    },
    {
      label: strings.organization_text_enquiry_template,
      value: '',
      type: 'upload',
      accept: 'text/html',
      placeholder: '',
      field: 'enquiryTemplate',
      validators: [],
      sx: { alignSelf: 'flex-start' },
      responsive: { xs: 12, md: 6 },
      required: false,
      multiline: false,
    },
    {
      label: strings.organization_text_piTemplate,
      value: '',
      type: 'upload',
      accept: 'text/html',
      placeholder: '',
      field: 'piTemplate',
      validators: [],
      sx: { alignSelf: 'flex-start' },
      responsive: { xs: 12, md: 6 },
      required: false,
      multiline: false,
    },
    {
      label: strings.organization_text_corporateRateTemplate,
      value: '',
      type: 'upload',
      accept: 'text/html',
      placeholder: '',
      field: 'corporateRateTemplate',
      validators: [],
      sx: { alignSelf: 'flex-start' },
      responsive: { xs: 12, md: 6 },
      required: false,
      multiline: false,
    },
  ];
};
